import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setResume, setIsResumeSubbed, setResumeSubDuration, setResumeServicesNumbers, setUser, setUserFirstName, setProfileImg, setUserResumesAll } from "../../redux/states";
import axios from "axios";
import { useErrorSetter, useSuccessSetter } from "../../hooks/useUiMessages";
import { ButtonThin } from "../UI/Buttons/Buttons";
import Button from "../UI/Buttons/Button";
import Alert from "@mui/material/Alert";
import { Rating } from "@mui/material";
import Slider from '@mui/material/Slider';
import { useTheme } from "../UI/Theme/ThemeContext";
import {
  DataContainerStyled,
  PageDataContainerStyled,
  StepsContainerStyled,
  EduCardStyled,
  ExpCardStyled,
  CertificationCardStyled,
  LanguageCardStyled,
  InfoContainerStyled,
} from "../../styled/Resume";
import { PreviewCourseModalStyled, CourseVideoRow, SaveIconStyled, SliderBox } from "../../styled/Resume";
import OvalSpinner from "../UI/Spinners/OvalSpinner";
import DataHeader from "./DataHeader";
import InputHandler from "./Tools/InputHandler";
import { Modal } from "../UI/Modal/Modal";
import ResumePricing from "../Pricing/ResumePricing";
import ProtectedContent from "../UI/ProtectedContent/ProtectedContent ";
import AuthHeader from "../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../UI/AuthSideMenu/AuthSideMenu";
import { LANGUAGES } from "../../utils/languages";
import { IoIosUnlock } from "react-icons/io";
import { GiGraduateCap } from "react-icons/gi";
import { MdDelete } from "react-icons/md";
import { FaLongArrowAltUp, FaLongArrowAltDown, FaPlay, FaRegBookmark, FaBookmark } from "react-icons/fa";
import { COUNTRIES } from '../../utils/countries';
import { checkAuthenticatedUser } from "../../utils/client-functions";
import { useConfirm } from "material-ui-confirm";
import { ButtonActionStyled } from "../../styled/Resume";
import chipCss from "./Chips.module.css";
import BubbleFloat from "../UI/BubbleFloat/BubbleFloat";
import MainModal from "../UI/Modal/MainModal";
import useYoutubeCourses from "../../hooks/useYoutubeCourses";
import RoadmapPreview from "./RoadmapPreview";

const langLevelsArray = [
  { name: "1" },
  { name: "2" },
  { name: "3" },
  { name: "4" },
  { name: "5" },
];

// reserved for local inline styles if needed

const PreviewResume = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeName } = useTheme();
  const errorSetter = useErrorSetter();
  const successSetter = useSuccessSetter();
  
  const confirm = useConfirm();

  const { resume, isResumeSubbed, user, resumeSubDuration, userResumesAll } = useSelector((state) => state.stateData);

  const [loading, setLoading] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [authMenuOpen, setAuthMenuOpen] = useState(false);
  const isAuth = typeof window !== 'undefined' ? localStorage?.getItem('token') : null;
  const [subsReady, setSubsReady] = useState(false);

  const [basicInfo, setBasicInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    jobPosition: "",
    city: "",
    country: "",
    profSummary: "",
  });
  const [linkInfo, setLinkInfo] = useState([]);
  const [skills, setSkills] = useState([]);
  const [eduArray, setEduArray] = useState([
    { institution: "", degree: "", date: "" },
  ]);
  const [workExpArray, setWorkExpArray] = useState([
    {
      company: "",
      position: "",
      dateFrom: "",
      dateTo: "",
      currently: false,
      industry: "",
      workLink: "",
      workLocation: "",
      jobDesc: "",
    },
  ]);
  const [awardArray, setAwardArray] = useState([{ org: "", award: "", date: "" }]);
  const [publications, setPublications] = useState([
    { title: "", source: "", date: "" },
  ]);
  const [languages, setLanguages] = useState([{ language: "", level: "" }]);
  const [interests, setInterests] = useState([]);
  const [isCourseModalOpen, setIsCourseModalOpen] = useState(false);
  // Ensure spinner shows immediately upon opening before fetch starts
  const [initialVideoLoading, setInitialVideoLoading] = useState(false);
  // Track completion of first fetch attempt to decide when to allow fallback rendering
  const [initialFetchDone, setInitialFetchDone] = useState(false);
  // Shared YouTube/course flow via hook (3 results in PreviewResume)
  const {
    youtubeVideoId, setYoutubeVideoId,
    youtubeVideos,
    selectedVideoIndex, setSelectedVideoIndex,
    selectedCountry, setSelectedCountry,
    setSelectedDuration,
    selectedDurationValue, setSelectedDurationValue,
    ytLoading,
    iframeLoading, setIframeLoading,
    savingCourse,
    courseSaved,
    fetchSavedCourses,
    fetchVideos,
    toggleSaveCurrent,
    invalidateFetchCache,
  } = useYoutubeCourses({
    maxResults: 3,
    token: isAuth,
    product: 'resume',
    onSubscriptionBlocked: () => { errorSetter('Upgrade to Per Week or Per Month to access AI-curated courses.'); setIsSubscribed(false); }
  });
  // Slider marks
  const durationMarks = [
    { value: 0, label: 'Short' },
    { value: 1, label: 'Medium' },
    { value: 2, label: 'Long' },
  ];

  // Build a resilient default query when resume insights don't include one
  const computeCourseQuery = () => {
    const insight = seniority?.courseRecommendation || seniority?.course;
    if (insight && String(insight).trim()) return String(insight).trim();
    const jp = basicInfo?.jobPosition && String(basicInfo.jobPosition).trim();
    if (jp) return `${jp} course`;
    const firstSkill = Array.isArray(skills) && skills.length > 0 ? String(skills[0]).trim() : '';
    if (firstSkill) return `${firstSkill} course`;
    return 'career development course';
  };

  // (selection of first video handled by the hook)

  const seniority = resume?.seniority; // optional insights if present

  // On open, seed defaults from seniority and fetch saved/videos
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!isCourseModalOpen) return;
      // seed defaults from resume insights for parity with previous logic
      const region = seniority?.courseVideoRegion || seniority?.country || '';
      const vd = seniority?.courseVideoDuration || 'long';
      if (region) setSelectedCountry(region);
      if (vd) {
        setSelectedDuration(vd);
        setSelectedDurationValue(vd === 'short' ? 0 : vd === 'medium' ? 1 : 2);
      }
      const query = computeCourseQuery();
      await fetchSavedCourses();
      if (cancelled) return;
      await fetchVideos(query);
      setInitialFetchDone(true);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCourseModalOpen]);

  // courseSaved sync is handled inside the useYoutubeCourses hook

  // (fetching is handled when opening via the above effect; slider/select will trigger refreshes)

  // Track iframe loading when video changes
  useEffect(() => {
    if (youtubeVideoId) {
      setIframeLoading(true);
    }
  }, [youtubeVideoId, setIframeLoading]);

  // Clear the initial opening spinner once a video ID appears or loading concludes
  useEffect(() => {
    if (initialVideoLoading && (youtubeVideoId || (initialFetchDone && !ytLoading && !iframeLoading))) {
      setInitialVideoLoading(false);
    }
  }, [initialVideoLoading, youtubeVideoId, ytLoading, iframeLoading, initialFetchDone]);

  // Seed local state from Redux resume on mount
  useEffect(() => {
    if (resume && Object.keys(resume).length > 0) {
      setBasicInfo({
        firstName: resume?.basicInfo?.firstName || "",
        lastName: resume?.basicInfo?.lastName || "",
        email: resume?.basicInfo?.email || "",
        mobile: resume?.basicInfo?.mobile || "",
        jobPosition: resume?.basicInfo?.jobPosition || "",
        city: resume?.basicInfo?.city || "",
        country: resume?.basicInfo?.country || "",
        profSummary: resume?.basicInfo?.profSummary || "",
      });
      setLinkInfo(Array.isArray(resume?.linkInfo) ? resume.linkInfo : []);
      setSkills(Array.isArray(resume?.skills) ? resume.skills : []);
      setEduArray(Array.isArray(resume?.eduArray) ? resume.eduArray : []);
      setWorkExpArray(
        Array.isArray(resume?.workExpArray) ? resume.workExpArray : []
      );
      setAwardArray(Array.isArray(resume?.awardArray) ? resume.awardArray : []);
      setPublications(
        Array.isArray(resume?.publications) ? resume.publications : []
      );
      setLanguages(Array.isArray(resume?.languages) ? resume.languages : []);
      setInterests(Array.isArray(resume?.interests) ? resume.interests : []);
    }
    // scroll to top for better UX
    window.scrollTo(0, 0);
  }, [resume]);

  // Career roadmap cache key
  const CAREER_ROADMAP_KEY = "careerRoadmapCache_v1";

  // Load career roadmap cache (if any) to enable preview-block in place of full seniority insights
  const [cachedRoadmap, setCachedRoadmap] = useState(null);
  useEffect(() => {
    try {
      const raw = localStorage?.getItem(CAREER_ROADMAP_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.expiration) return;
      if (Date.now() > parsed.expiration) { localStorage?.removeItem(CAREER_ROADMAP_KEY); return; }
      setCachedRoadmap(parsed);
    } catch (_) {}
  }, []);

  // Fallback bootstrapping on direct visit/reload: hydrate from localStorage or send back to Customize
  useEffect(() => {
    // If Redux already has resume data, no action needed
    if (resume && Object.keys(resume || {}).length > 0) return;

    const LOCAL_KEY =
      "5787378Tgigi879889%%%%7]][][]]]=-9-0d90900io90799CVBcvVVHGGYUYFUYIOUIUTY0I9T]---000789XZJHVB[[[27627787tdtu&3$*))(990-__)((@@";
    try {
      const cached = localStorage?.getItem(LOCAL_KEY);
      if (!cached) {
        navigate("/user/dashboard/resume?customize", { replace: true });
        return;
      }
      const parsed = JSON.parse(cached);
      const now = Date.now();
      if (!parsed || !parsed.expiration || now > parsed.expiration) {
        // expired or invalid cache; clean up and send back to customize
        try { localStorage?.removeItem(LOCAL_KEY); } catch (_) {}
        navigate("/user/dashboard/resume?customize", { replace: true });
        return;
      }
      // resumeData can be an object or a stringified object literal; normalize
      let hydrated = parsed.resumeData;
      if (typeof hydrated === "string") {
        try {
          // eslint-disable-next-line no-new-func
          hydrated = new Function(`return (${hydrated})`)();
        } catch (_) {
          // Not an object-literal string; try JSON parse as a fallback
          try { hydrated = JSON.parse(hydrated); } catch (_) {}
        }
      }
      if (!hydrated || typeof hydrated !== "object") {
        navigate("/user/dashboard/resume?customize", { replace: true });
        return;
      }
      // If there's a cached career roadmap and the hydrated resume lacks one, inject it as a lightweight preview
      try {
        const roadmapRaw = localStorage?.getItem(CAREER_ROADMAP_KEY);
        if (roadmapRaw) {
          const roadmapParsed = JSON.parse(roadmapRaw);
          if (roadmapParsed && roadmapParsed.data && (!hydrated.seniority || !hydrated.seniority.careerRoadmap)) {
            hydrated.seniority = hydrated.seniority || {};
            hydrated.seniority.careerRoadmap = roadmapParsed.data;
          }
        }
      } catch (_) {}
      // Put into Redux; our other effect will seed local UI state
      dispatch(setResume(hydrated));
    } catch (e) {
      navigate("/user/dashboard/resume?customize", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ensure auth/session + subscription context
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await checkAuthenticatedUser();
      } catch (_) {
        if (!cancelled) {
          navigate("/popin?resume");
          setSubsReady(true);
        }
        return;
      }
      try {
        const response = await axios.get("/user/resume", {
          headers: { "x-access-token": isAuth },
        });
        if (response?.data?.status === "unauthenticated") {
          localStorage?.removeItem("token");
          if (!cancelled) {
            navigate("/popin?resume");
            setSubsReady(true);
          }
          return;
        }
        const {
          firstName,
          profileImg,
          resumeSubscriptions,
          resumes,
          resumeTotalNumbers,
        } = response?.data?.user || {};

        // Mirror old flow store population
        dispatch(setUserResumesAll(resumes || []));
        dispatch(setUser(response?.data?.user || {}));
        if (firstName) dispatch(setUserFirstName(firstName));
        if (profileImg) dispatch(setProfileImg(profileImg));
        if (resumeSubscriptions) {
          dispatch(setIsResumeSubbed(!!resumeSubscriptions?.subscribed));
          dispatch(setResumeSubDuration(resumeSubscriptions?.duration || ""));
        }
        if (resumeTotalNumbers) {
          dispatch(setResumeServicesNumbers(resumeTotalNumbers));
        }
      } catch (e) {
        // Soft-fail: keep page usable
      } finally {
        if (!cancelled) setSubsReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleResumes = () => setAuthMenuOpen((v) => !v);

  // Handlers
  const handleUnlockEdit = () => {
    setIsSubscribed(false); // open pricing modal
  };

  const handleInputChange = (prop) => (eventOrValue) => {
    const value = eventOrValue?.target ? eventOrValue.target.value : eventOrValue;
    setBasicInfo((prev) => ({ ...prev, [prop]: value }));
  };

  const handleDeleteLinks = (index) => {
    const value = linkInfo?.[index];
    confirm({
      title: `Delete Link${value ? `: ${String(value).slice(0, 30)}` : ""}?`,
      description: "Click OK to delete this link.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setLinkInfo((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleDeleteSkills = (index) => {
    const value = skills?.[index];
    confirm({
      title: `Delete Skill${value ? `: ${String(value).slice(0, 30)}` : ""}?`,
      description: "Click OK to delete this skill.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setSkills((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleEduExpChange = (e, index) => {
    const { name, value } = e.target;
    setEduArray((prev) => prev.map((it, i) => (i === index ? { ...it, [name]: value } : it)));
  };
  const moveEduUp = (index) => {
    if (index === 0) return;
    setEduArray((prev) => {
      const arr = [...prev];
      [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
      return arr;
    });
  };
  const moveEduDwn = (index) => {
    setEduArray((prev) => {
      if (index >= prev.length - 1) return prev;
      const arr = [...prev];
      [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];
      return arr;
    });
  };
  const deleteEduItem = (index) => {
    const item = eduArray?.[index];
    const label = item ? `${item.degree || ""} ${item.institution ? `@ ${item.institution}` : ""}`.trim() : "";
    confirm({
      title: `Delete Education${label ? `: ${label.slice(0, 40)}` : ""}?`,
      description: "Click OK to remove this education entry.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setEduArray((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleWorkExpChange = (e, index) => {
    const { name } = e.target;
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setWorkExpArray((prev) => prev.map((it, i) => (i === index ? { ...it, [name]: value } : it)));
  };
  const moveExpUp = (index) => {
    if (index === 0) return;
    setWorkExpArray((prev) => {
      const arr = [...prev];
      [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
      return arr;
    });
  };
  const moveExpDwn = (index) => {
    setWorkExpArray((prev) => {
      if (index >= prev.length - 1) return prev;
      const arr = [...prev];
      [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];
      return arr;
    });
  };
  const deleteWorkExp = (index) => {
    const item = workExpArray?.[index];
    const label = item ? `${item.position || ""} ${item.company ? `@ ${item.company}` : ""}`.trim() : "";
    confirm({
      title: `Delete Experience${label ? `: ${label.slice(0, 40)}` : ""}?`,
      description: "Click OK to remove this experience entry.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setWorkExpArray((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleAwardChange = (e, index) => {
    const { name, value } = e.target;
    setAwardArray((prev) => prev.map((it, i) => (i === index ? { ...it, [name]: value } : it)));
  };
  const moveAwardUp = (index) => {
    if (index === 0) return;
    setAwardArray((prev) => {
      const arr = [...prev];
      [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
      return arr;
    });
  };
  const moveAwardDwn = (index) => {
    setAwardArray((prev) => {
      if (index >= prev.length - 1) return prev;
      const arr = [...prev];
      [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];
      return arr;
    });
  };
  const deleteAward = (index) => {
    const item = awardArray?.[index];
    const label = item ? `${item.award || ""} ${item.org ? `@ ${item.org}` : ""}`.trim() : "";
    confirm({
      title: `Delete Award${label ? `: ${label.slice(0, 40)}` : ""}?`,
      description: "Click OK to remove this award.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setAwardArray((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handlePubChange = (e, index) => {
    const { name, value } = e.target;
    setPublications((prev) => prev.map((it, i) => (i === index ? { ...it, [name]: value } : it)));
  };
  const movePubUp = (index) => {
    if (index === 0) return;
    setPublications((prev) => {
      const arr = [...prev];
      [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
      return arr;
    });
  };
  const movePubDwn = (index) => {
    setPublications((prev) => {
      if (index >= prev.length - 1) return prev;
      const arr = [...prev];
      [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];
      return arr;
    });
  };
  const deletePub = (index) => {
    const item = publications?.[index];
    const label = item?.title || "";
    confirm({
      title: `Delete Publication${label ? `: ${label.slice(0, 40)}` : ""}?`,
      description: "Click OK to remove this publication/project.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setPublications((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleLangChange = (e, index) => {
    const { name, value } = e.target;
    setLanguages((prev) => prev.map((it, i) => (i === index ? { ...it, [name]: value } : it)));
  };
  const deleteLang = (index) => {
    const item = languages?.[index];
    const label = item ? `${item.language || ""}${item.level ? ` (Level ${item.level})` : ""}` : "";
    confirm({
      title: `Delete Language${label ? `: ${label.slice(0, 40)}` : ""}?`,
      description: "Click OK to remove this language.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setLanguages((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleDeleteInterests = (index) => {
    const value = interests?.[index];
    confirm({
      title: `Delete Interest${value ? `: ${String(value).slice(0, 30)}` : ""}?`,
      description: "Click OK to delete this interest.",
      cancellationText: "Cancel",
      confirmationText: "OK",
    })
      .then(() => setInterests((prev) => prev.filter((_, i) => i !== index)))
      .catch(() => {});
  };

  const handleFormSubmit = () => {
    try {
      const updatedResume = {
        ...resume,
        basicInfo,
        linkInfo: (linkInfo || []).filter(Boolean),
        skills: (skills || []).filter(Boolean),
        eduArray: eduArray || [],
        workExpArray: workExpArray || [],
        awardArray: awardArray || [],
        publications: publications || [],
        languages: languages || [],
        interests: interests || [],
      };
      dispatch(setResume(updatedResume));
      setLoading(true);
      // small delay for modal feedback before navigating
      setTimeout(() => {
        navigate("/user/dashboard/resume?download");
        setLoading(false);
      }, 200);
    } catch (err) {
      errorSetter("Couldn't prepare resume for download. Please try again.");
    }
  };

  return (
    <ProtectedContent>
      <div className="auth-container">
        {/* SIDE MENU */}
        <AuthSideMenu
          opened={authMenuOpen}
          hidden={!authMenuOpen}
          resumeSubDuration={resumeSubDuration}
          isResumeSubbed={isResumeSubbed}
          arrayDetails={userResumesAll}
          firstName={user?.firstName}
        />

        <BubbleFloat />

        <div className="auth-container-inner">
          {/* Top authenticated header with working hamburger */}
          <AuthHeader authMenuOpen={authMenuOpen} onClick={toggleResumes} headerText="Preview Resume" />

          <DataContainerStyled theme={themeName} onClick={() => setAuthMenuOpen(false)}>
          <DataHeader activeStep={2} />
          <div className="dataContent">
            <PageDataContainerStyled theme={themeName}>
              <div style={{ width: "95%", margin: "0.5rem auto" }}>
                <Alert sx={{ padding: "0 5px", fontSize: ".7rem" }} severity="warning">
                  On the job description field, make sure each point is separated by a semi colon (<b>;</b>) (if you decide to edit it) to enable proper formatting on the download page.
                </Alert>
                <Alert sx={{ padding: "0 5px", fontSize: ".7rem" }} severity="warning">
                  Always read the generated resume carefully and make edits to imprint your personal touch.
                </Alert>
              </div>

              {(() => {
                const hasRoadmapPreview = Boolean((cachedRoadmap && cachedRoadmap.data) || (resume?.seniority && resume.seniority.careerRoadmap));
                if (hasRoadmapPreview) {
                  const roadmapData = (cachedRoadmap && cachedRoadmap.data) || (resume?.seniority && resume.seniority.careerRoadmap);
                  return (
                    <div style={{ width: '95%', margin: '0.5rem auto 0.25rem' }}>
                      <RoadmapPreview roadmap={roadmapData} seniority={seniority.level} />
                    </div>
                  );
                }
                return (
                  seniority && (
                    <InfoContainerStyled theme={themeName} style={{ marginTop: seniority?.insight ? '0.5rem' : undefined }}>
                      <div className="insightsGrid">
                        <div>
                          <div>
                            <strong>Level:</strong>
                          </div>
                          <div>
                            <Rating
                              name="read-only"
                              value={seniority.level}
                              size="large"
                              precision={1}
                              readOnly
                            />
                          </div>
                          <div style={{ fontSize: ".8rem", marginTop: "0.5rem" }}>
                            <div>
                              <strong>Career Insight:</strong>
                            </div>
                            Based on my analysis of your certifications, work experience and education, your resume level is <strong>{seniority?.description}</strong>. This can be further <strong>improved</strong> by gaining more certifications, courses, projects or volunteering for experience.
                          </div>
                        </div>
                        <div>
                          {seniority?.insight && (
                            <div style={{ margin: "10px auto" }}>
                              <div>
                                <strong>Resume Insight:</strong>
                              </div>
                              {subsReady && !isResumeSubbed ? (
                                <ButtonThin
                                  onClick={handleUnlockEdit}
                                  width={"150px"}
                                  height="20px"
                                  color="#EE7B1C"
                                  border="2px solid #EE7B1C"
                                >
                                  Unlock &nbsp; &nbsp;
                                  <IoIosUnlock />
                                </ButtonThin>
                              ) : (
                                <p style={{ fontSize: ".8rem" }}>{seniority?.insight}</p>
                              )}
                            </div>
                          )}
                        </div>
                        <div>
                          <div>
                            <strong>Recommended Certification/Course:</strong>
                          </div>
                          <div
                            style={{
                              fontSize: ".8rem",
                              margin: "10px auto",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <div style={{display: 'flex'}}>
                                <GiGraduateCap style={{ color: "#EE7B1C", fontSize: "1.3rem" }} />
                                &nbsp;&nbsp; <strong>{seniority?.courseRecommendation}</strong> <br />
                              </div>

                              <p style={{ paddingLeft: '10px' }}>Based on deep AI analysis, this course is strongly recommended to greatly improve your employment chances. You can view and save it for later before returning to continue with your resume below.</p>

                              <div style={{ marginTop: "10px" }}>
                                <ButtonThin
                                  onClick={() => {
                                    if (subsReady && !isResumeSubbed) return handleUnlockEdit();
                                    // Enforce tier: Per Week or Per Month only
                                    const allowed = (resumeSubDuration === 'Per Week' || resumeSubDuration === 'Per Month');
                                    if (!allowed) {
                                      errorSetter('This feature requires Per Week or Per Month subscription.');
                                      setIsSubscribed(false); // open pricing modal
                                      return;
                                    }
                                    // Open modal; show initial spinner instantly
                                    setInitialVideoLoading(true);
                                    setIsCourseModalOpen(true);
                                  }}
                                  width={"200px"}
                                  height="40px"
                                  color="#EE7B1C"
                                  border="2px solid #EE7B1C"
                                >
                                  <FaPlay style={{ color: "crimson", fontSize: "1.3rem" }} /> &nbsp;
                                  View/Save Course
                                </ButtonThin>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </InfoContainerStyled>
                  )
                );
              })()}

              {/* Course Modal - minimalistic video preview and save action */}
              <MainModal isOpen={isCourseModalOpen} onClose={() => setIsCourseModalOpen(false)} width={"50%"} height={520}>
                <div>
                  <PreviewCourseModalStyled>
                      <h3>{seniority?.courseRecommendation || "Recommended Course"}</h3>
                      <p>{(youtubeVideos?.[selectedVideoIndex]?.description) || seniority?.courseDescription || ""}</p>
                      <CourseVideoRow>
                        <div className="videoWrapper">
                          {(ytLoading || iframeLoading || initialVideoLoading) && (
                            <div style={{position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', background:'#efefef'}}>
                              <OvalSpinner size={36} color="#5fbec5" />
                            </div>
                          )}
                      {(() => {
                        const embedFromYouTube = youtubeVideoId ? `https://www.youtube.com/embed/${youtubeVideoId}` : null;
                        // Only allow legacy links AFTER first fetch completes and no YouTube result
                        const legacySrc = (!embedFromYouTube && initialFetchDone && !(ytLoading || iframeLoading || initialVideoLoading))
                          ? (seniority?.courseVideoSource || seniority?.courseLink || seniority?.courseUrl || null)
                          : null;
                        if (embedFromYouTube) {
                          return (
                            <iframe
                              src={embedFromYouTube}
                              title="Course video"
                                  style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                  onLoad={() => setIframeLoading(false)}
                            />
                          );
                        }
                        if (legacySrc) {
                          return (
                            <iframe
                              src={legacySrc}
                              title="Course video"
                              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              onLoad={() => setIframeLoading(false)}
                            />
                          );
                        }
                        // Only show fallback text after initial fetch attempt finishes
                        if (initialFetchDone && !(ytLoading || iframeLoading || initialVideoLoading)) {
                          return (
                            <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#f6f6f6", color: "#444" }}>
                              <span>No preview available</span>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  </CourseVideoRow>
                  {/* videoChoices moved below controls to follow the requested layout */}
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    {/* Duration selector (MUI Slider) */}
                      <SliderBox>
                        <Slider
                          value={selectedDurationValue}
                          onChange={(e, val) => {
                            // val is numeric 0,1,2
                            setSelectedDurationValue(val);
                            setSelectedDuration(val === 0 ? 'short' : val === 1 ? 'medium' : 'long');
                          }}
                          onChangeCommitted={() => { invalidateFetchCache(); fetchVideos(computeCourseQuery()); }}
                          step={1}
                          marks={durationMarks}
                          min={0}
                          max={2}
                          aria-label="video-duration"
                          sx={{
                            color: '#5fbec5',
                            height: 3,
                            padding: '2px 0',
                            '& .MuiSlider-rail': { opacity: 0.3, backgroundColor: 'rgba(95,190,197,0.30)' },
                            '& .MuiSlider-track': { border: 'none', backgroundColor: '#5fbec5' },
                            '& .MuiSlider-thumb': {
                              height: 12,
                              width: 12,
                              backgroundColor: '#fff',
                              border: '2px solid #5fbec5',
                              boxShadow: 'none',
                              '&:hover, &.Mui-focusVisible, &.Mui-active': { boxShadow: '0 0 0 6px rgba(95,190,197,0.16)' }
                            },
                            '& .MuiSlider-markLabel, & .MuiSlider-markLabelActive': { fontSize: '0.7rem' }
                          }}
                        />
                      </SliderBox>

                    {/* Country selector styled like Upload/Paste button */}
                    <div style={{ marginRight: 8 }}>
                      <select
                        value={selectedCountry}
                        onChange={(e) => { setSelectedCountry(e.target.value); invalidateFetchCache(); fetchVideos(computeCourseQuery()); }}
                        style={{
                          height: 34,
                          padding: '4px 8px',
                          borderRadius: 9,
                          // background: themeName === 'dark' ? '#122732' : '#fff',
                          color: '#111',
                          border: '1px solid rgba(0,0,0,0.12)',
                          width: (typeof window !== 'undefined' ? ((window.innerWidth||0) < 600) : false) ? '120px' : '200px',
                          minWidth: 120,
                          maxWidth: 200
                        }}
                        title="Filter by country"
                      >
                        <option value="">Choose region</option>
                        {COUNTRIES && COUNTRIES.map((c, idx) => (
                          <option key={`${c.code}-${idx}`} value={c.code}>{c.name} ({c.code})</option>
                        ))}
                      </select>
                    </div>

                    <SaveIconStyled
                      className={courseSaved ? 'saved' : undefined}
                      saved={courseSaved}
                      title={courseSaved ? "Unsave" : "Save Course"}
                      onClick={async () => {
                        const res = await toggleSaveCurrent({
                          title: youtubeVideos?.[selectedVideoIndex]?.title || seniority?.courseRecommendation || 'Course',
                          description: youtubeVideos?.[selectedVideoIndex]?.description || seniority?.courseDescription || '',
                          thumbnail: youtubeVideos?.[selectedVideoIndex]?.thumbnail || '',
                          sourceQuery: seniority?.courseRecommendation || seniority?.course || '',
                        });
                        if (res.ok) {
                          if (res.action === 'saved') successSetter('Course saved');
                          if (res.action === 'unsaved') successSetter('Removed from saved');
                        } else {
                          errorSetter('Could not update saved course. Please try again.');
                        }
                      }}
                    >
                      {savingCourse ? (
                        <OvalSpinner size={18} color="#5fbec5" />
                      ) : courseSaved ? (
                        <FaBookmark color="#5fbec5" />
                      ) : (
                        <FaRegBookmark color="#5fbec5" />
                      )}
                    </SaveIconStyled>
                  </div>

                      {/* Explain controls */}
                      <Alert severity="info" sx={{ mt: 1, fontSize: '.8rem', '& .MuiAlert-message': { width: '100%' } }}>
                        Use the range to pick course length (Short/Medium/Long), then optionally filter by country to localize results. Click a thumbnail to switch the main video, and tap the bookmark to save or unsave the course for later.
                      </Alert>
                      <Alert severity="info" sx={{ mt: 1, fontSize: '.8rem', '& .MuiAlert-message': { width: '100%' } }}>
                        To view saved courses from anywhere: <strong>Top right menu → <Link to="/user/dashboard/courses" style={{ color: '#5fbec5', textDecoration: 'underline' }}>Ai Curated Courses</Link>.</strong>
                      </Alert>

                  {/* Relevant Courses list (thumbnails) */}
                  {Array.isArray(youtubeVideos) && youtubeVideos.length > 0 && (
                    <div style={{ marginTop: 12 }}>
                      <h4 style={{ margin: '8px 0', color: '#000' }}>Free Videos</h4>
                      <div className="videoChoices">
                        {youtubeVideos.map((v, idx) => (
                          <div key={v.videoId || v.title || idx} style={{ display: 'inline-block', marginRight: 8 }}>
                            <img
                              src={v.thumbnail || ''}
                              alt={v.title || `video-${idx}`}
                              className={`thumb ${selectedVideoIndex === idx ? 'selected' : ''}`}
                              onClick={() => {
                                if (v && v.videoId) {
                                  setYoutubeVideoId(v.videoId);
                                  setSelectedVideoIndex(idx);
                                }
                              }}
                              style={{ display: 'block' }}
                            />
                            <div style={{ maxWidth: 140, fontSize: 12, marginTop: 6 }}>{v.title}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                    {ytLoading && (
                      <div style={{ marginTop: 12, width:'100%' }}>
                        <h4 style={{ margin: '8px 0', color: themeName === 'dark' ? '#fff' : '#000' }}>Relevant Courses</h4>
                        <div className="videoChoices">
                          {[0,1,2].map((i) => (
                            <div key={i} style={{ display:'inline-block', marginRight:8 }}>
                              <div className="thumbLoader" />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </PreviewCourseModalStyled>
                </div>
              </MainModal>

              <StepsContainerStyled theme={themeName}>
                <h2>Basic Information</h2>
                <div className="basic">
                  <InputHandler
                    type="text"
                    id="basicInfo.firstName"
                    name="firstName"
                    value={basicInfo?.firstName || ""}
                    label="First Name"
                    required
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("firstName")}
                  />
                  <InputHandler
                    type="text"
                    id="basicInfo.lastName"
                    name="lastName"
                    value={basicInfo?.lastName || ""}
                    label="Last Name"
                    required
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("lastName")}
                  />
                  <InputHandler
                    type="email"
                    id="basicInfo.email"
                    name="email"
                    value={basicInfo?.email || ""}
                    label="Email"
                    required
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("email")}
                  />
                  <InputHandler
                    type="mobile"
                    id="basicInfo.mobile"
                    name="mobile"
                    value={basicInfo?.mobile || ""}
                    label="Mobile"
                    required
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("mobile")}
                  />
                  <InputHandler
                    type="text"
                    id="basicInfo.jobPosition"
                    name="jobPosition"
                    value={basicInfo?.jobPosition || ""}
                    label="Job Position (NOT editable)"
                    disabled
                    onChange={handleInputChange("jobPosition")}
                  />
                  <InputHandler
                    type="select"
                    label="Country"
                    id="basicInfo.country"
                    name="country"
                    value={basicInfo?.country || ""}
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("country")}
                  />
                  <InputHandler
                    type="select"
                    label="State"
                    id="basicInfo.city"
                    country={basicInfo?.country}
                    name="city"
                    value={basicInfo?.city || ""}
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("city")}
                  />
                </div>
                <div style={{ width: "95%", margin: "0 auto" }}>
                  <div style={{ textAlign: "center", width: "100%" }}>
                    <h4>AI Generated Prof. Summary</h4>
                  </div>
                  <InputHandler
                    type="textBox"
                    id="basicInfo.profSummary"
                    name="profSummary"
                    value={basicInfo?.profSummary || ""}
                    placeholder="AI Generated Prof. Summary"
                    disabled={!isResumeSubbed || !subsReady}
                    onChange={handleInputChange("profSummary")}
                  />
                </div>
                {Array.isArray(linkInfo) && linkInfo.length > 0 && (
                  <div style={{ width: "95%", margin: "0.5rem auto" }}>
                    <h4 style={{ margin: 0, textAlign: "center" }}>Your Links</h4>
                    <div style={{ padding: "2px 0", display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                      {linkInfo.map((link, index) => (
                        <span key={index} className={`${chipCss.chip} array-item`}>
                          {link}
                          <span
                            className={chipCss.deleteBtn}
                            title="Delete Link"
                            onClick={() => handleDeleteLinks(index)}
                          >
                            <MdDelete className={chipCss.deleteIcon} />
                          </span>
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </StepsContainerStyled>

              {skills?.length > 0 && (
                <div className="Segment">
                  <h2 style={{ color: themeName === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit', textAlign: 'center' }}>Relevant Skills</h2>
                  <div style={{ padding: "5px", display: "flex", flexWrap: "wrap" }}>
                    {skills?.map((skill, index) => (
                      <span key={index} className={`${chipCss.chip} array-item`}>
                        {skill}
                        <span
                          className={chipCss.deleteBtn}
                          title="Delete Skill"
                          onClick={() => handleDeleteSkills(index)}
                        >
                          <MdDelete className={chipCss.deleteIcon} />
                        </span>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {eduArray && eduArray.length > 0 && (
                <>
                  <h2 style={{ width: "95%", margin: "1rem auto 0", color: themeName === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit', textAlign: 'center' }}>Education Info</h2>
                  {subsReady && !isResumeSubbed && (
                    <div
                      style={{
                        width: "95%",
                        margin: "0.25rem auto",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <ButtonThin
                        onClick={handleUnlockEdit}
                        width={"120px"}
                        height="20px"
                        color="#EE7B1C"
                      >
                        unlock editing <IoIosUnlock />
                      </ButtonThin>
                    </div>
                  )}
                  {eduArray?.map((info, index) => (
                    <EduCardStyled theme={themeName} key={index}>
                      <div className="inputs">
                        <InputHandler
                          type="education"
                          id={`info.institution.${index}`}
                          name="institution"
                          value={info.institution}
                          label="Name of Institution"
                          required
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(event) => handleEduExpChange(event, index)}
                        />
                        <InputHandler
                          type="education"
                          id={`info.degree.${index}`}
                          name="degree"
                          value={info.degree}
                          label="Degree Obtained"
                          required
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(event) => handleEduExpChange(event, index)}
                        />
                        <InputHandler
                          type="date"
                          id={`info.date.${index}`}
                          name="date"
                          value={info.date}
                          label="Graduation Date"
                          required
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(event) => handleEduExpChange(event, index)}
                        />
                      </div>
                      {eduArray?.length > 1 && (
                        <ButtonActionStyled>
                          <span className="del" title="delete item" onClick={() => deleteEduItem(index)}>
                            <MdDelete />
                          </span>
                          <span className="add" title="move up" onClick={() => moveEduUp(index)}>
                            <FaLongArrowAltUp />
                          </span>
                          <span className="add" title="move down" onClick={() => moveEduDwn(index)}>
                            <FaLongArrowAltDown />
                          </span>
                        </ButtonActionStyled>
                      )}
                    </EduCardStyled>
                  ))}
                </>
              )}

              {workExpArray && workExpArray.length > 0 && (
                <>
                  <h2 style={{ width: "95%", margin: "1rem auto 0", color: themeName === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit', textAlign: 'center' }}>
                    Work & Volunteering Experience
                  </h2>
                  {subsReady && !isResumeSubbed && (
                    <div
                      style={{
                        width: "95%",
                        margin: "0.25rem auto",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <ButtonThin
                        onClick={handleUnlockEdit}
                        width={"120px"}
                        height="20px"
                        color="#EE7B1C"
                      >
                        unlock editing <IoIosUnlock />
                      </ButtonThin>
                    </div>
                  )}
                  {workExpArray?.map((info, index) => (
                    <ExpCardStyled theme={themeName} key={index}>
                      <div className="input">
                        <InputHandler
                          type="experience"
                          label="Company/Org. Name"
                          name="company"
                          value={info.company}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                        <InputHandler
                          type="experience"
                          label="Position Held"
                          name="position"
                          value={info.position}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                        <InputHandler
                          type="experience"
                          label="Industry e.g IT"
                          name="industry"
                          value={info.industry}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                        <InputHandler
                          type="experience"
                          label="Related Link"
                          name="workLink"
                          value={info.workLink}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                        <InputHandler
                          type="experience"
                          label="Location"
                          name="workLocation"
                          value={info.workLocation || ""}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                        <InputHandler
                          type="experience"
                          label="From"
                          name="dateFrom"
                          value={info.dateFrom}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed}
                        />
                        <InputHandler
                          type="experience"
                          label="To"
                          name="dateTo"
                          value={info.dateTo}
                          onChange={(e) => handleWorkExpChange(e, index)}
                          disabled={!isResumeSubbed || !subsReady || info.currently}
                        />
                      </div>
                      <span className="currently">
                        <InputHandler
                          type="checkbox"
                          name="currently"
                          id={`currently-${index}`}
                          value={!!info.currently}
                          label="I currently work here"
                          onChange={(e) => handleWorkExpChange(e, index)}
                          inputStyle={{ accentColor: '#EE7B1C', outline: 'none' }}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                      </span>
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <h4>Ai Generated Job Description</h4>
                      </div>
                      <InputHandler
                        type="textBox"
                        label="Job Description"
                        name="jobDesc"
                        value={info.jobDesc}
                        onChange={(e) => handleWorkExpChange(e, index)}
                        disabled={!isResumeSubbed || !subsReady}
                      />
                      {workExpArray?.length > 1 && (
                        <ButtonActionStyled>
                          <span className="del" title="delete item" onClick={() => deleteWorkExp(index)}>
                            <MdDelete />
                          </span>
                          <span className="add" title="move up" onClick={() => moveExpUp(index)}>
                            <FaLongArrowAltUp />
                          </span>
                          <span className="add" title="move down" onClick={() => moveExpDwn(index)}>
                            <FaLongArrowAltDown />
                          </span>
                        </ButtonActionStyled>
                      )}
                    </ExpCardStyled>
                  ))}
                </>
              )}

              {awardArray && awardArray.length > 0 && (
                <>
                  <h2 style={{ width: "95%", margin: "1rem auto 0", color: themeName === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit', textAlign: 'center' }}>
                    Awards & Accomplishments
                  </h2>
                  {subsReady && !isResumeSubbed && (
                    <div
                      style={{
                        width: "95%",
                        margin: "0.25rem auto",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <ButtonThin
                        onClick={handleUnlockEdit}
                        width={"120px"}
                        height="20px"
                        color="#EE7B1C"
                      >
                        unlock editing <IoIosUnlock />
                      </ButtonThin>
                    </div>
                  )}
                  {awardArray?.map((info, index) => (
                    <CertificationCardStyled theme={themeName} key={index}>
                      <div className="input">
                        <InputHandler
                          type="text"
                          name="org"
                          value={info.org}
                          label="Awarding Organization"
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(e) => handleAwardChange(e, index)}
                        />
                        <InputHandler
                          type="text"
                          name="award"
                          value={info.award}
                          label="Award Received"
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(e) => handleAwardChange(e, index)}
                        />
                        <InputHandler
                          type="date"
                          name="date"
                          value={info.date}
                          label="Date Awarded"
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(e) => handleAwardChange(e, index)}
                        />
                      </div>
                      {awardArray?.length > 1 && (
                        <ButtonActionStyled>
                          <span className="del" title="delete item" onClick={() => deleteAward(index)}>
                            <MdDelete />
                          </span>
                          <span className="add" title="move up" onClick={() => moveAwardUp(index)}>
                            <FaLongArrowAltUp />
                          </span>
                          <span className="add" title="move down" onClick={() => moveAwardDwn(index)}>
                            <FaLongArrowAltDown />
                          </span>
                        </ButtonActionStyled>
                      )}
                    </CertificationCardStyled>
                  ))}
                </>
              )}

              {publications && publications.length > 0 && (
                <>
                  <h2 style={{ width: "95%", margin: "1rem auto 0", color: themeName === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit', textAlign: 'center' }}>
                    Publications & Projects
                  </h2>
                  {subsReady && !isResumeSubbed && (
                    <div
                      style={{
                        width: "95%",
                        margin: "0.25rem auto",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <ButtonThin
                        onClick={handleUnlockEdit}
                        width={"120px"}
                        height="20px"
                        color="#EE7B1C"
                      >
                        unlock editing <IoIosUnlock />
                      </ButtonThin>
                    </div>
                  )}
                  {publications?.map((info, index) => (
                    <CertificationCardStyled theme={themeName} key={index}>
                      <div className="input">
                        <InputHandler
                          type="text"
                          name="title"
                          value={info.title}
                          label="Publication Title"
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(e) => handlePubChange(e, index)}
                        />
                        <InputHandler
                          type="text"
                          name="source"
                          value={info.source}
                          label="Source"
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(e) => handlePubChange(e, index)}
                        />
                        <InputHandler
                          type="date"
                          name="date"
                          value={info.date}
                          label="Date Awarded"
                          disabled={!isResumeSubbed || !subsReady}
                          onChange={(e) => handlePubChange(e, index)}
                        />
                      </div>
                      {publications?.length > 1 && (
                        <ButtonActionStyled>
                          <span className="del" title="delete item" onClick={() => deletePub(index)}>
                            <MdDelete />
                          </span>
                          <span className="add" title="move up" onClick={() => movePubUp(index)}>
                            <FaLongArrowAltUp />
                          </span>
                          <span className="add" title="move down" onClick={() => movePubDwn(index)}>
                            <FaLongArrowAltDown />
                          </span>
                        </ButtonActionStyled>
                      )}
                    </CertificationCardStyled>
                  ))}
                </>
              )}

              {interests && interests.length > 0 && (
                <div className="Segment">
                  <h2 style={{ color: themeName === 'dark' ? 'rgba(255, 205, 41, 1)' : 'inherit', textAlign: 'center' }}>Interests</h2>
                  <div style={{ padding: "5px", display: "flex", flexWrap: "wrap" }}>
                    {interests.map((interest, index) => (
                      <span key={index} className={`${chipCss.chip} array-item`}>
                        {interest}
                        <span
                          className={chipCss.deleteBtn}
                          title="Delete Interest"
                          onClick={() => handleDeleteInterests(index)}
                        >
                          <MdDelete className={chipCss.deleteIcon} />
                        </span>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {languages && languages.length > 0 && (
                <LanguageCardStyled theme={themeName}>
                  <div className="items">
                    {languages.map((language, index) => (
                      <div className="languageWrapper" key={index}>
                        <InputHandler
                          type="language"
                          languageValue={language.language}
                          languageName="language"
                          languageLabel="Language"
                          languageList={LANGUAGES}
                          languageOnChange={(event) => handleLangChange(event, index)}
                          levelValue={language.level}
                          levelName="level"
                          levelLabel="Level"
                          levelList={langLevelsArray}
                          levelOnChange={(event) => handleLangChange(event, index)}
                          handleDeleteLang={() => deleteLang(index)}
                          disabled={!isResumeSubbed || !subsReady}
                        />
                      </div>
                    ))}
                  </div>
                </LanguageCardStyled>
              )}

              <div className="optimizeBtnRow">
                <Button
                  primary
                  width="100%"
                  title="Choose Template"
                  clickHandle={handleFormSubmit}
                />
              </div>
            </PageDataContainerStyled>
          </div>
        </DataContainerStyled>
        {loading && (
          <Modal
            header4={`Hello ${basicInfo.firstName}`}
            header3="Preping Resume for download..."
          />
        )}
        {!isSubscribed && <ResumePricing closePricing={() => navigate('/user/dashboard/resume')} open />}
      </div>
      </div>
    </ProtectedContent>
  );
};

export default PreviewResume;
